import { useQueryState, parseAsString } from 'nuqs'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableFilterSelector } from '@/common/ui/table/data-table-filter-selector'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { DataTableSimpleSearch } from '@/common/ui/table/data-table-simple-search'
import { TOURNAMENT_PLAYER_STATUS_OPTIONS } from '@/modules/tournament/constants'
import { tournamentPlayersColumns } from './constants'
import type { components } from '@/schema'

type TournamentPlayer = components['schemas']['AdminTournamentPlayerResponse']

interface TournamentPlayersTableProps {
	data: TournamentPlayer[]
	total: number
	isLoading: boolean
}

export default function TournamentPlayersTable({
	data,
	total,
	isLoading,
}: TournamentPlayersTableProps) {
	const [, setStatusFilter] = useQueryState(
		'status',
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSimpleSearch placeHolder="ค้นหาผู้เล่น (เบอร์โทร, ชื่อผู้ใช้)..." />
				<DataTableFilterSelector
					options={TOURNAMENT_PLAYER_STATUS_OPTIONS}
					placeholder="เลือกสถานะ"
					label="สถานะ"
					onValueChange={(value) => setStatusFilter(value || null)}
				/>
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={tournamentPlayersColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
